import React, { useState, useEffect, useRef } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { useDispatch, useSelector } from 'react-redux';
import { contactUsLisitingRequest, deleteContactUs } from './redux/contactUsDispatcher';
import Swal from 'sweetalert2';
import { useLocation } from 'react-router-dom';

function ContactUsListingTable() {
  const dispatch = useDispatch();
  const location = useLocation();
  const contactUsListing = useSelector(state => state.contactUsReducer);

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const columns = [
    {
      field: "id",
      headerName: "NO",
      width: 60,
      renderCell: (params) =>
        params.api.getRowIndexRelativeToVisibleRows(params.id) + 1 + (page * pageSize),
    },
        { field: "created_at", headerName: "Created At", width: 100 },

    { field: "name", headerName: "Name", width: 150 },
    { field: "email", headerName: "Email", width: 150 },
    { field: "subject", headerName: "Make", width: 150 },
    { field: "message", headerName: "Message", width: 200 },
    {
      field: "action",
      headerName: "Action",
      width: 180,
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", gap: "6px", height:"100%", alignItems:"center" }}> 
         
          <button
            onClick={() => handleDelete(params.row)}
            style={{
              backgroundColor: "#F44336",
              color: "white",
              border: "none",
              borderRadius: "4px",
              fontSize: "10px",
              padding: "4px 8px",
              cursor: "pointer",
              minWidth: "40px",
              height:"24px",  // Increased height
              padding: "2px 5px", // Added padding
              display: "flex",
              alignItems: "center",
              // alignSelf:"end",
              justifyContent: "center",
            }}
          >
            Delete
          </button>
        </div>
      )
    }
  ];








  const handleDelete = (row) => {
    Swal.fire({
      title: '',
      html: `Are you sure?<br>You want to delete this "${row.name}" request`,
      showCancelButton: true,
      confirmButtonText: 'Yes, Delete',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    }).then(result => {
      if (result.isConfirmed) {
        dispatch(deleteContactUs(row.id));
      }
    });
  };







  useEffect(() => {
          dispatch(contactUsLisitingRequest(page + 1, pageSize));

  }, [page, pageSize, dispatch, location.pathname]);



  return (
    <Paper sx={{ height: "95%", width: '100%' }}>
     
      <DataGrid
        rows={contactUsListing.contactUsListing || []}
        columns={columns}
        rowCount={contactUsListing.totalContactUs || 0}
         paginationModel={{ page, pageSize }}
        paginationMode="server"
        onPaginationModelChange={({ page, pageSize }) => {
          console.log("pagination----",page,pageSize);
          setPage(page);
          setPageSize(pageSize);
        }}
        pageSizeOptions={[10, 25, 50]}
        loading={contactUsListing.loading}
        rowHeight={36}
        disableRowSelectionOnClick
      />
    </Paper>
  );
}

export default ContactUsListingTable;
